module.exports = __webpack_public_path__ + "static/media/VISITAS_EDUCATIVAS.b2fe02cc.pdf";